import React from "react";
import { useNavigate } from "react-router-dom";
import { viewHref } from "@shared/navigation/tabs/ViewsProvider";

/**
 * A link to another detail view, with the treatment the list ID links have
 * (brand, underlined) and opened the same way, so it works in a view tab.
 */
export const DetailLink: React.FC<{ to: string; label: string }> = ({
  to,
  label,
}) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      {...viewHref(to)}
      onClick={() => navigate(to)}
      className="
        hover:text-semantic-text-brand
        hover:underline
        focus:underline
        active:underline
        font-medium
        underline
        text-semantic-text-brand
        text-sm
      "
    >
      {label}
    </button>
  );
};
